// Canonical clipboard write for the server-rendered layer. The async
// Clipboard API is the primary path; the off-screen-textarea execCommand
// fallback covers non-secure contexts (older Safari / plain HTTP) and
// writeText rejections (permission denied, unfocused document).
//
// Resolves true/false and never rejects, so call sites only decide what
// feedback to show. Stimulus buttons that copy STATIC text should use
// clipboard_controller instead; import this only when the copied text is
// assembled at click time.
export async function copyTextToClipboard(text) {
  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text)
      return true
    } catch {
      return legacyCopy(text)
    }
  }

  return legacyCopy(text)
}

function legacyCopy(text) {
  const textarea = document.createElement("textarea")
  textarea.value = text
  textarea.setAttribute("readonly", "")
  textarea.style.position = "absolute"
  textarea.style.left = "calc(-1 * var(--gl-size-9999))"
  document.body.appendChild(textarea)
  textarea.select()
  let copied = false
  try {
    copied = document.execCommand("copy")
  } catch {
    copied = false
  }
  document.body.removeChild(textarea)
  return copied
}
